let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("A2U1w")).then(() => parcelRequire('b1dTE'));